export default __webpack_public_path__ + "static/media/BrandsWeServe.245330eb.png";